import * as React from 'react';
import PropTypes from "prop-types"
import { Button } from "../ecosystem/";
const InHomeSchedulingButtons = (props) => {
    const disabled = !!props?.disabledNext;
    return (
        <div className="row buttons-wrapper with-margins">
            <div className="col-12 buttons">
                <Button
                    fluid
                    variant="secondary"
                    icon="chevron-left"
                    iconPosition="left"
                    onClick={props.leftOnClick}
                >
                    {props.leftBtnLabel}
                </Button>
                <Button
                    fluid
                    icon="chevron-right"
                    iconPosition="right"
                    onClick={props.rightOnClick}
                    disabled={disabled}
                >
                    {props.rightBtnLabel}
                </Button>
            </div>
        </div>
    )
}

InHomeSchedulingButtons.defaultProps = {
    leftBtnLabel: "Previous",
    rightBtnLabel: "Next",
    showWarning: false,
    warningText: "Please make a selection."
}

InHomeSchedulingButtons.propTypes = {
    leftBtnLabel: PropTypes.string,
    rightBtnLabel: PropTypes.string,
    leftOnClick: PropTypes.func,
    rightOnClick: PropTypes.func,
    showWarning: PropTypes.bool,
    warningText: PropTypes.string,
}

export default InHomeSchedulingButtons